import screenshot1 from '../assets/images/gurugramuniversitydemo.png';
import screenshot2 from '../assets/images/gurugramuniversitydemo1.png';
import screenshot3 from '../assets/images/gurugramuniversitydemo2.png';
import screenshot4 from '../assets/images/gurugramuniversitydemo3.png';


const screenshot = [
  {
    id: 1,
    imageUrl: screenshot1,
    alt: 'Screenshot of the Virtual Real-Time Attendance Ecosystem dashboard'
  },
  {
    id: 2,
    imageUrl: screenshot2,
    alt: 'Screenshot of the Virtual Real-Time Attendance Ecosystem dashboard'
  },
  {
    id: 3,
    imageUrl: screenshot3,
    alt: 'Screenshot of the Virtual Real-Time Attendance Ecosystem dashboard'
  },
  {
    id: 4,
    imageUrl: screenshot4,
    alt: 'Screenshot of the Virtual Real-Time Attendance Ecosystem dashboard'
  }
]

const PortfolioSection = () => {
  const handleConsultationClick = (event) => {
    event.preventDefault();
    const contactSection = document.querySelector('#connect');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    window.dispatchEvent(new Event('open-connect'));
  };

  return (
    <section id="portfolio" className="relative py-20 px-6 z-10">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between mb-16 gap-8">
          <div>
            <p className="text-sm uppercase tracking-[0.3em] text-indigo-300">Our Work</p>
            <h2 className="text-4xl md:text-5xl font-bold text-white mt-4">Virtual Real-Time Attendance Ecosystem</h2>
          </div>
          <div className="w-full lg:w-2/5">
            <p className="text-gray-300 leading-relaxed">
              A seamlessly connected attendance experience that integrates biometric devices, live dashboards, and automated payroll insights to keep distributed teams in sync.
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          <div className="space-y-10">
            <div className="bg-gray-800/40 border border-gray-700/60 rounded-2xl p-8 shadow-lg shadow-indigo-900/20">
              <h3 className="text-2xl font-semibold text-white mb-6">Project Overview</h3>
              <div className="space-y-6 text-gray-300">
                <div>
                  <h4 className="text-lg font-semibold text-indigo-300">The Problem</h4>
                  <p className="mt-2 leading-relaxed">
                    Enterprises struggled to reconcile fragmented attendance data across branches, leading to payroll delays, compliance risks, and limited visibility into workforce performance.
                  </p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-indigo-300">Our Solution</h4>
                  <p className="mt-2 leading-relaxed">
                    We delivered a unified attendance ecosystem with biometric integration, geo-fenced mobile check-ins, and AI-driven anomaly detection that keeps HR teams informed in real time.
                  </p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-indigo-300">Key Features</h4>
                  <ul className="mt-3 space-y-2 list-disc list-inside">
                    <li>Live attendance monitoring with predictive staffing alerts.</li>
                    <li>Automated compliance checks and audit-ready reporting.</li>
                    <li>Self-service employee portal with leave and shift management.</li>
                    <li>Payroll-ready exports integrated with accounting platforms.</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-gray-800/30 border border-gray-700/60 rounded-2xl p-8">
              <h3 className="text-2xl font-semibold text-white mb-4">Technologies We Used</h3>
              <div className="flex flex-wrap gap-3">
                {['React', 'Node.js', 'PostgreSQL', 'Supabase Auth', 'Tailwind CSS', 'AWS Lambda', 'WebSockets'].map((tech) => (
                  <span
                    key={tech}
                    className="px-4 py-2 rounded-full bg-indigo-600/20 border border-indigo-500/40 text-indigo-200 text-sm font-medium"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-8">
            <div className="grid sm:grid-cols-2 gap-6">
              {screenshot.map(({ id, imageUrl, alt }) => (
                <div
                  key={id}
                  className="relative h-48 sm:h-56 rounded-2xl overflow-hidden bg-gradient-to-br from-indigo-700/60 via-purple-600/50 to-blue-600/40 border border-gray-700/60"
                >
                  <img
                    src={imageUrl}
                    alt={alt}
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                </div>
              ))}
            </div>

            <div className="bg-gray-900/40 border border-gray-700/60 rounded-2xl p-8">
              <h3 className="text-xl font-semibold text-white mb-4">Impact Delivered</h3>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-start gap-3">
                  <span className="text-indigo-400">▹</span>
                  <span>70% faster payroll reconciliation with automated calculations.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-indigo-400">▹</span>
                  <span>Real-time dashboards adopted across 25+ locations within the first month.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-indigo-400">▹</span>
                  <span>95% reduction in manual attendance corrections.</span>
                </li>
              </ul>
            </div>

            <div className="flex items-center justify-center gap-4 -mt-3">
              {/* Each button gets 'flex-1' to share the space equally */}
              <a
                href="#connect"
                onClick={handleConsultationClick}
                className="flex-1 inline-flex items-center justify-center bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-lg text-base font-semibold text-center transition-all duration-300 transform hover:scale-105"
              >
                Request a Consultation
              </a>

              {/* This button also gets 'flex-1' */}
              <a
                href="/blog"
                className="flex-1 inline-flex items-center justify-center border border-indigo-500/60 text-indigo-300 hover:bg-indigo-500/10 hover:border-indigo-500 px-6 py-3 rounded-lg text-base font-semibold text-center transition-colors duration-300"
              >
                Learn More →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
